import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { MONTHS } from '../../utils/Constants';
import GeneralUtil from '../../utils/GeneralUtil';

class HomepageEvents extends Component {
  state = {
    start: 1,
    end: 3

  }
  componentDidMount(){
    
  }
  nextClick = (total) => {
    let end = this.state.end + 3;
    
    this.setState({
      start: this.state.start + 3,
      end: this.state.end + 3
    })
  }
  backClick = () => {
    this.setState({
      start: this.state.start - 3,
      end: this.state.end - 3
    })
  }
  getClassName = (idx) => {
    let className = '';
    if(idx + 1 < this.state.start || idx + 1 > this.state.end){
      className = 'hide';
    }
    return className;
  }
  formatDate = (ts) => {
    var date = new Date(ts);
    var day = date.getDate();
    var month = MONTHS[date.getMonth()];
    var year = date.getFullYear();
    var fullDate = day + ' ' + month + ', ' + year;
    return fullDate;
  }
  formatTime = (ts) => {
    var date = new Date(ts);
    var hour = date.getHours();
    var min = date.getMinutes();
    min = GeneralUtil.pad('00', min, true);
    var type = 'AM';
    if(hour > 12){
      hour = hour - 12;
      type = 'PM';
    }
    return hour + ':' + min + type;
  }
  render(){
    let events = this.props.events;
    let total = this.props.events.length;
    return(
      <div>

      <h2 className="no-margin events-heading">What's on in Basildon</h2>
        
        <div className="grid-container">
          <div className="grid-x grid-margin-x events-block">
          { events.map((item, idx) => (
            
            <div key={idx} className={`medium-4 cell event-cell ${this.getClassName(idx)}`}>
                <article className="event-item">
                  
                  <h3 className="event-title no-margin"><a href={item.url} className="details-link" target="_blank">{item.name.text}</a></h3>
                  <div className="date">{this.formatDate(item.start.local)}, {this.formatTime(item.start.local)}</div>
                  <div className="location">
                    <a href={item.url} target="_blank">More Info</a>
                  </div>
                  
                </article>
            </div>
          ))
          }

          </div>

          <div className="grid-x event-navigation">
            <div className="large-12 cell">
              { this.state.start > 1 && 
              <button onClick={this.backClick}>&laquo; Back</button> 
              }
              { this.state.end < total && 
                <button onClick={this.nextClick}>Next &raquo;</button>
              }
            </div>
          </div>

          <div className="grid-x event-promo-wrapper">
            <div className="large-12 cell">
              <Link to="/getfound">Get your event listed here</Link>
            </div>
            
          </div>
        </div>
      </div>
    );
  }
}
export default HomepageEvents;


// WEBPACK FOOTER //
// ./src/components/blocks/HomepageEventsEventbriteAPI.js